import Module from '../../../module';
import scroll from '../../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsResourcesSharedSubmenuItemCls: string;
			investorsResourcesSharedSubmenuStarCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Resources Shared Submenu Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesSharedSubmenuItemCls + '1', 'investors_resources_shared_submenu', { animCls: 'animate__zoomIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesSharedSubmenuItemCls + '2', 'investors_resources_shared_submenu', { animCls: 'animate__zoomIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesSharedSubmenuItemCls + '3', 'investors_resources_shared_submenu', { animCls: 'animate__zoomIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesSharedSubmenuItemCls + '4', 'investors_resources_shared_submenu', { animCls: 'animate__zoomIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesSharedSubmenuStarCls + '1', 'investors_resources_shared_submenu', { animCls: 'animate__rotateIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesSharedSubmenuStarCls + '2', 'investors_resources_shared_submenu', { animCls: 'animate__rotateIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesSharedSubmenuStarCls + '3', 'investors_resources_shared_submenu', { animCls: 'animate__rotateIn', dontClearDelay: true, once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;